import React from "react";
import { observer } from "mobx-react";
import { Glyphicon, Alert } from "react-bootstrap";

import MultiSelectWithDoDOrdering from "../../../general/MultiSelectWithDoDOrdering";
import { TooltipWithText } from "../../tooltip/TooltipWithText";

import "./CubeRelationships.scss";

/**
 * @typedef {import("../../../stores/CubeQueryWizard/CubeQueryWizardStore").default} CubeQueryWizardStore
 */

/**
 *
 * @param {{store: CubeQueryWizardStore}} props
 * @returns
 */
const CubeRelationshipsComponent = ({ store }) =>
  Object.keys(store.cubeRelationships).length > 0 && (
    <section className="CubeRelationships">
      <h4 className="CubeRelationships_header">
        Link with data of other Cubes of the Data Model
        <TooltipWithText id="cube_relationships_info">
          <span className="sr-only">Info:</span>
          This section allows you to join/link different tables (Cubes)
          belonging to the same Data model (e.g. connecting AnaCredit Instrument
          fact table with AnaCredit Debtor non anonymised table). The respective
          fields (Variables) will also then be visible for selection in the
          current Query. The join criteria is "LEFT JOIN", please update
          directly the generated query in case of a different need.
        </TooltipWithText>
      </h4>
      <Alert bsStyle="warning">
        <div>
          <Glyphicon glyph="info-sign" /> Please be aware that with the current
          version of the feature it's only possible to link/join a certain Cube
          once. Please update the query in case it's needed to join multiple
          times on the same Cube.
        </div>
      </Alert>
      <div>
        <MultiSelectWithDoDOrdering
          disabled={store.filterByVariableDisabled}
          options={store.cubeRelationshipsOptions}
          order={store.selectedCubeRelationships}
          values={store.selectedCubeRelationships}
          placeholder="Select link to Cube"
          allowSelectMultipleTimes={false}
          onChangeOrder={store.addSelectedCubeRelationshipsItem}
          onAdd={store.addSelectedCubeRelationshipsItem}
          onDelete={store.deleteAllSelectedCubeRelationshipsItems}
        >
          {store.selectedCubeRelationships.map((cubeId) => (
            <div key={cubeId} className="CubeQueryWizard__row item">
              {store.foreignCubes[cubeId].loading ? (
                <div className="x-icon">
                  <div className="query-wizard-loader"></div>
                </div>
              ) : (
                <div
                  className="x-icon"
                  aria-hidden="true"
                  onClick={() =>
                    store.deleteSelectedCubeRelationshipsItem(cubeId)
                  }
                >
                  ×
                </div>
              )}
              <div className="item-texts">
                {`${store.foreignCubes[cubeId].details.name} (${
                  store.foreignCubes[cubeId].details.code
                }) ${
                  store.foreignCubes[cubeId].loading
                    ? "(Wait while loading cube structure)"
                    : ""
                }`}
              </div>
            </div>
          ))}
        </MultiSelectWithDoDOrdering>
      </div>
      <hr />
    </section>
  );

export const CubeRelationships = observer(CubeRelationshipsComponent);
